import { EffectUI } from 'game/extended/uis/effects/EffectUI'
import React from 'react'

import { BerserkEffect } from './berserk_effect'
import image from './berserk_effect.png'

export const berserk_effect_ui: EffectUI<'BerserkEffect'> = {
    model: BerserkEffect,
    label: 'Berserk bonus',
    image,
    renderDescription: (effect: BerserkEffect) => <>
        Your strength is increased and each additional stack will further increase this.
    </>,
    renderTable: (effect: BerserkEffect, UI) => <>
        <UI.TRow >
            <UI.TKey>Stacks: </UI.TKey>
            <UI.TVal>{effect.stacks}</UI.TVal>
        </UI.TRow>
        <UI.TRow >
            <UI.TKey>Increase: </UI.TKey>
            <UI.TVal><UI.Stat stat='strength' amount={effect.increase} /></UI.TVal>
        </UI.TRow>
    </>
}
